import type { BusinessLoggerRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'businessLogger'
const businessLoggerRefProvider = getSiteFeatureBoundRefProvider(featureName)

const businessLoggerRefs: BusinessLoggerRefs = {
	reportBi: () => businessLoggerRefProvider(['reportBi']),
}
export { businessLoggerRefs }
